import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

interface SortingByIndicators {
  name: string,
  icon: string,
  slug: string,
  active: boolean
}

const DEFAULT_CATEGORY_SLUG = 'score';
const ALL_TEAMS_VIEW_KEY = 'all-teams';

@Component({
  selector: 'app-to-page-header',
  templateUrl: './to-page-header.component.html',
  styleUrls: ['./to-page-header.component.scss']
})

export class ToPageHeaderComponent implements OnInit {
  @Output() setDaysForSwitch = new EventEmitter<any>();
  @Output() setIndicatorForSort = new EventEmitter<any>();
  @Input() set selectedViewUuid(value: string | null) {
    const nextUuid = value || null;
    if (!this.viewSelectionReady) {
      this.activeViewUuid = nextUuid;
      this.viewSelectionReady = true;
      return;
    }
    if (this.activeViewUuid === nextUuid) {
      return;
    }
    this.activeViewUuid = nextUuid;
    this.applyCategoryForActiveView();
  }

  sortingByIndicators: SortingByIndicators[] = [
    {name: this.translate.instant('team_score'), icon: '',slug: 'score', active: true},
    {name: this.translate.instant('team_performance'), icon: 'performance',slug: 'performance', active: false},
    {name: this.translate.instant('team_satisfaction'), icon: 'satisfaction',slug: 'satisfaction', active: false},
    {name: this.translate.instant('team_motivation'), icon: 'motivation',slug: 'motivation', active: false},
    {name: this.translate.instant('team_stress_free'), icon: 'stress',slug: 'stress', active: false},
  ];

  is30DaysSorting: boolean = true;
  is90DaysSorting: boolean = false;
  private activeViewUuid: string | null = null;
  private viewSelectionReady = false;
  private categoryByView = new Map<string, string>();

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
  }

  sortByDays(days: number) {
    if (days === 30) {
      this.is30DaysSorting = true;
      this.is90DaysSorting = false;
    } else {
      this.is90DaysSorting = true;
      this.is30DaysSorting = false;
    }
    this.setDaysForSwitch.emit(days);
  }

  sortByCategory(categoryIndex: number) {
    if (categoryIndex < 0) {
      return;
    }
    this.sortingByIndicators.forEach((indicator: any, index: number) => {
      if (categoryIndex === index) {
        indicator.active = true;
        this.categoryByView.set(this.viewKey(this.activeViewUuid), indicator.slug);
        this.setIndicatorForSort.emit(indicator.slug);
      } else {
        indicator.active = false;
      }
    });
  }

  private applyCategoryForActiveView() {
    const slug = this.categoryByView.get(this.viewKey(this.activeViewUuid)) || DEFAULT_CATEGORY_SLUG;
    const currentSlug = this.sortingByIndicators.find((indicator: SortingByIndicators) => indicator.active)?.slug;
    this.sortingByIndicators.forEach((indicator: SortingByIndicators) => {
      indicator.active = indicator.slug === slug;
    });
    if (currentSlug !== slug) {
      this.setIndicatorForSort.emit(slug);
    }
  }

  private viewKey(viewUuid: string | null): string {
    return viewUuid || ALL_TEAMS_VIEW_KEY;
  }
}
